// The rules that make two patient records look like the same person, as the backend matcher names
// them (PatientLookalikeService / the duplicate report). Shared by the Potential Duplicates report
// and the Patient Profile's look-alike decisions, which store the codes comma-joined.

export const LOOKALIKE_RULES = {
  SAME_CNIC: { label: 'Same CNIC', tier: 4 },
  SAME_BFORM: { label: 'Same B-Form', tier: 4 },
  // Requires the names to match too. A shared CNIC stem alone is NOT a duplicate signal: families
  // share the leading digits, so the stem-only version paired fathers with daughters.
  CNIC_TYPO: { label: 'Same name, CNIC differs by last digit', tier: 3 },
  NAME_DOB: { label: 'Name and date of birth', tier: 3 },
  NAME_PHONE: { label: 'Name and phone', tier: 3 },
  NAME_GUARDIAN: { label: 'Name and guardian CNIC', tier: 3 },
  NAME_PARENT: { label: 'Name and father or husband', tier: 2 },
  PHONE_DOB: { label: 'Phone and date of birth', tier: 2 },
  GUARDIAN_DOB: { label: 'Same guardian and date of birth', tier: 2 },
  SAME_NAME: { label: 'Same name', tier: 1 },
};

/** The rule codes on a row ({ rules: 'A,B' }), strongest first. */
export const lookalikeRulesOf = (row) =>
  (row?.rules || '')
    .split(',')
    .filter(Boolean)
    .sort((a, b) => (LOOKALIKE_RULES[b]?.tier || 0) - (LOOKALIKE_RULES[a]?.tier || 0));

export const lookalikeRuleLabel = (code) => LOOKALIKE_RULES[code]?.label || code;
